import React from 'react';
import { CatalogSimpleContainer } from 'containers/product-catalog/CatalogSimple';

export const CatalogSimpleSlice = ({ title, tagline, tags, items, lang, isSlice }) => {
  const tagList = tags ? tags.split(',').map((s) => s.trim()) : [];

  return (
    <CatalogSimpleContainer
      title={title}
      tagline={tagline}
      filters={tagList}
      catalog={items?.filter(
        (item) => tagList.length < 1 || item.tags.some((t) => tagList.includes(t))
      )}
      lang={lang}
      isSlice={isSlice}
    />
  );
};

export default CatalogSimpleSlice;
